export default __webpack_public_path__ + "static/media/Avatar5.25a7b967.png";